/* gangsheet-no-default-size.js
   Gang sheet BUILDERS — DTF (build-your-own-gang-sheet) AND UV
   (uv-dtf-gang-sheet-builder): default the size selection to the SMALLEST
   variant on landing (Owen, 2026-08-14 — this REVERSES the file's original
   "no default" behavior; the filename is kept because three layouts load it
   by name). Shopify server-checks the DEFAULT variant's size radio, and the
   admin re-sort app can make that any size — this pins the landing default
   to the smallest real size (DTF "1 Foot"; Add-on values are skipped — they
   are customer-hidden `_addon-hidden` items). On the DTF builder the film
   (option 2, VIVID AF) is owned by dtf-film-style-lock.js — never touched
   here. Scope:
     • DTF builder  → body `template-product-build-a-gang-sheet`            → RUNS
     • UV builder   → `…-build-a-gang-sheet-uv` (contains that substring)   → RUNS
     • Uploads      → `nt-gs-sheet` (no build-a-gang-sheet)                 → not matched
   Rules:
     • ?variant= deep links are respected (checked at boot, before the theme
       rewrites the URL) — a shared 20 Feet link still lands on 20 Feet.
     • A customer's own click is never undone: a user-checked radio has
       .checked without the server `checked` ATTRIBUTE — we bail on those.
     • When the server default already IS the smallest, no events fire
       (nothing changes); we only flip + dispatch when they differ. */
(function () {
  'use strict';
  var cls = document.body.className || '';
  if (cls.indexOf('template-product-build-a-gang-sheet') < 0) return; // DTF + UV builders only (uploads use nt-gs-sheet, not matched)

  // Respect deep links: captured at boot, before theme JS replaceState()s the URL.
  if (/[?&]variant=/.test(location.search)) return;

  function sizeInches(v) {
    var m = (v || '').match(/([\d.]+)\s*(inch|inches|foot|feet)/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return /foot|feet/i.test(m[2]) ? n * 12 : n;
  }

  function selectSmallest() {
    var c1 = document.querySelector('.product-variant__container[option="1"]');
    if (!c1) return;
    var radios = Array.prototype.slice.call(c1.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;
    // Customer already picked (checked property without the server attribute) → hands off.
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked && !radios[i].hasAttribute('checked')) return;
    }
    var best = null, bestIn = Infinity;
    radios.forEach(function (r) {
      if (r.disabled) return;
      if (/add-on/i.test(r.value || '')) return; // customer-hidden _addon-hidden items
      var n = sizeInches(r.value);
      if (n != null && n < bestIn) { bestIn = n; best = r; }
    });
    if (!best || best.checked) return;
    best.checked = true;
    best.dispatchEvent(new Event('input', { bubbles: true }));
    best.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selectSmallest);
  else selectSmallest();
  setTimeout(selectSmallest, 150);
  setTimeout(selectSmallest, 400);
  setTimeout(selectSmallest, 700);

  /* Builder exit: restore sticky header + clear floating pins.
     gang-edit.min.js sets body.style.overflow = "hidden" on open, then
     restores it to "auto" on close (via postMessage gs_close_builder).
     TWO problems result from leaving overflow:"auto" on body:
       1. position:sticky on the header stops working — same as overflow:hidden,
          sticky requires no ancestor with overflow set to anything but "visible".
       2. The scroll position is unchanged (user was scrolled down to reach the
          Build button), so the header chip stays above the viewport and the
          floating pins keep showing.
     Fix: intercept the "auto" restore, clear the inline style entirely
     (→ CSS default "visible" → sticky recovers), then jump to top so the
     header chip is back in view and both pin scripts re-evaluate to hidden. */
  if (typeof MutationObserver !== 'undefined') {
    var prevOverflow = document.body.style.overflow;
    new MutationObserver(function () {
      var cur = document.body.style.overflow;
      if (prevOverflow === 'hidden' && (cur === 'auto' || cur === '')) {
        /* Clear gang-edit's overflow:"auto" so the CSS default "visible"
           applies → position:sticky on the header works again. */
        document.body.style.overflow = '';
        prevOverflow = '';
        /* Scroll to top: header chip back in view → pins re-evaluate to hidden. */
        window.scrollTo(0, 0);
        setTimeout(function () {
          window.dispatchEvent(new Event('scroll'));
        }, 50);
        return; // skip the prevOverflow = cur line below
      }
      prevOverflow = cur;
    }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  }
})();
